<template>
  <div
    class="route-item-bd tb"
    v-if="funcView.route_list"
  >
    <div class="search-hd">
      <el-form
        :inline="true"
        @submit.native.prevent
      >
        <!-- 导出excel -->
        <el-form-item
          style="float: right; margin-right: 0"
          v-if="exportExcelVisible"
        >
          <el-button
            class="table-set"
            style="vertical-align: top"
            @click="exportTable"
          ><i class="icon icon-daochu"></i></el-button>
        </el-form-item>
        <!-- 搜索栏 -->
        <el-form-item
          style="float: right"
          :class="exportExcelVisible ? '' : 'mr-0'"
        >
          <search-input
            v-model="formSearch.siteName"
            @fetch="onPageChange({ page: 1 })"
            :placeholder="$t('dms_routeManage.qu_yu')"
          ></search-input>
        </el-form-item>
        <!-- 更多搜索 -->
        <el-form-item style="float: right">
          <switch-button :link="link"></switch-button>
        </el-form-item>
      </el-form>
    </div>
    <switch-container
      ref="container"
      @search="onPageChange({ page: 1 })"
      @clear="clearFilter()"
    >
      <el-form
        :inline="true"
        label-position="top"
      >
        <template>
          <!-- 产品型号 -->
          <el-form-item :label="$t('dms_routeManage.chan_pin_xing_hao')">
            <el-input
              v-model="formSearch.productCode"
              clearable
            ></el-input>
          </el-form-item>
          <!-- 起点码 -->
          <el-form-item :label="$t('dms_routeManage.qi_dian_ma')">
            <el-input
              v-model="formSearch.hlcCode"
              clearable
            ></el-input>
          </el-form-item>
          <!-- 路线名称 -->
          <el-form-item :label="$t('dms_routeManage.lu_xian_ming_cheng')">
            <el-input
              v-model="formSearch.mapName"
              clearable
            ></el-input>
          </el-form-item>
          <!-- 组织名称 -->
          <el-form-item :label="$t('dms_routeManage.zu_zhi_ming_cheng')">
            <el-input
              v-model="formSearch.orgName"
              clearable
            ></el-input>
          </el-form-item>
          <!-- 项目名称 -->
          <el-form-item :label="$t('dms_routeManage.xiang_mu')">
            <el-input
              v-model="formSearch.locationName"
              clearable
            ></el-input>
          </el-form-item>
          <!-- 创建人 -->
          <el-form-item :label="$t('dms_routeManage.chuang_jian_ren')">
            <el-input
              v-model="formSearch.creator"
              clearable
            ></el-input>
          </el-form-item>
          <!-- 创建时间 -->
          <el-form-item :label="$t('dms_routeManage.chuang_jian_shi_jian')">
            <custom-date-picker
              style="width: 100%"
              v-model="formSearch.gmtCreate"
              type="daterange"
              align="right"
              value-format="YYYY-MM-DD HH:mm:ss"
              clearable
            ></custom-date-picker>
          </el-form-item>
          <!-- 机身号 -->
          <el-form-item :label="$t('dms_routeManage.ji_shen_hao')">
            <el-input
              v-model="formSearch.bodyNum"
              clearable
            ></el-input>
          </el-form-item>
        </template>

      </el-form>
    </switch-container>
    <div class="table-bd">
      <custom-table
        ref="table"
        height="100%"
        :data="tableList"
        :column="tableColumn"
        @sort="sortChange"
        @filter="filterChange"
        index
        :slots="['deviceCounts', 'count', 'action']"
      >
        <template v-slot:count="scope">
          {{scope.row.slotCounts || 0}}/6
        </template>
        <template v-slot:deviceCounts="scope">
          <el-popover
            @after-enter="showPopover(scope.row)"
            @after-leave="hidePopover(scope.row)"
            width="500"
            placement="bottom"
            trigger="hover"
          >
            <device-list-detail
              v-if="scope.row.popover"
              :siteId="scope.row.siteId"
            ></device-list-detail>
            <span
              style="text-align: center; padding: 0 10px"
              class="table-link"
              slot="reference"
            >{{scope.row.deviceCounts}}</span>
          </el-popover>
        </template>
        <template v-slot:action="scope">
          <span>
            <el-button
              v-if="funcView.route_detail"
              type="text"
              size="mini"
              @click="showSlotList(scope.row)"
            >{{funcView.route_detail}}</el-button>
            <el-button
              v-if="funcView.route_history_record"
              type="text"
              size="mini"
              @click="showRouteHistory(scope.row)"
            >{{funcView.route_history_record}}</el-button>
          </span>
        </template>
      </custom-table>
    </div>
    <div class="table-page">
      <custom-page
        :total="totalRows"
        :page="formSearch.pageNum"
        :size="formSearch.pageSize"
        @change="onPageChange"
      ></custom-page>
    </div>
    <slot-list-dialog
      v-if="slotListVisible"
      @close="slotListVisible=false"
      :model="slotListModel"
    ></slot-list-dialog>
    <route-history-dialog
      v-if="routeHistoryVisible"
      @close="routeHistoryVisible=false"
      :model="routeHistoryModel"
    ></route-history-dialog>
  </div>
</template>

<script>
import apis from '@/utils/apis';
import deviceListDetail from './children/device_list_detail.vue';
import slotListDialog from './children/slot_list_dialog.vue';
import routeHistoryDialog from './children/route_history_dialog.vue';


export default {
  name: 'routeManage',
  mixins: [],
  components: {
    deviceListDetail,
    slotListDialog,
    routeHistoryDialog
  },
  props: {
  },
  data() {
    return {
      link: null,
      formSearch: {
        search: '',
        pageSize: 50,
        pageNum: 1,

        productCode: '',
        // 起点码
        hlcCode: '',
        // 路线名称
        mapName: '',
        // 组织名称
        orgName: '',
        // 项目名称
        locationName: '',
        // 区域名称
        siteName: '',
        // 创建人
        creator: '',
        // 创建时间
        gmtCreate: '',
        // 机身号
        bodyNum: '',
        // 操作时间
        operateTime: '',
      },
      tableList: [],
      totalRows: null,
      tableCode: 'dms_route_manage',

      editRouteNameVisible: false,
      editRouteNameModel: {},

      checkSourceVisible: false,
      checkSourceModel: {},

      translateMapVisible: false,
      translateMapModel: {},

      slotListVisible: false,
      slotListModel: {},

      routeHistoryVisible: false,
      routeHistoryModel: {},
    };
  },
  computed: {

    exportExcelVisible() {
      return false;
    }
  },
  watch: {
  },
  filters: {
  },
  directives: {
  },
  methods: {
    showRouteHistory(row) {
      // 定位码/项目名称/区域名称 hlcCode, locationName, siteName
      const { hlcCode, locationName, siteName } = row;
      const title = [hlcCode, locationName, siteName].join('/');
      this.routeHistoryModel = {
        title,
        data: row
      };
      this.routeHistoryVisible = true;
    },

    showSlotList(row) {
      const {
        hlcCode, locationName, siteName
      } = row;
      const title = [hlcCode, locationName, siteName].join('/');
      this.slotListModel = {
        // 定位码/项目名称/区域名称  hlcCode  locationName  siteName
        title,
        data: row
      };
      this.slotListVisible = true;
    },
    // 判断是否为转移数据
    isTranslate(row) {
      if (this.dicMap.hlc_slot_state) {
        return `${this.dicMap.hlc_slot_state.transfer}` === `${row.hlcSlotState}`;
      }
      return false;
    },
    isDelStatus(row) {
      if (this.dicMap.hlc_slot_state) {
        return `${this.dicMap.hlc_slot_state.remove}` === `${row.hlcSlotState}`;
      }
      return false;
    },
    hidePopover(row) {
      this.$set(row, 'popover', false);
    },
    showPopover(row) {
      this.$set(row, 'popover', true);
    },
    onTranslate(row) {
      this.translateMapModel = {
        title: this.$t('dms_routeManage.zhuan_yi_lu_xian'),
        data: row
      };

      this.translateMapVisible = true;
    },
    onCheckSource(row) {
      const { hlcCode, siteName, slotCode } = row;
      const slotCodeName = this.dicMap.sbr_slot[slotCode];
      const str = [hlcCode, siteName, slotCodeName].filter(val => val).join('/');
      const tips = this.$t('dms_routeManage.cha_kan_lai_yuano', [str]);
      this.checkSourceModel = {
        title: tips,
        data: row
      };

      this.checkSourceVisible = true;
    },

    onEditRouteName(row) {
      const { hlcCode, siteName, slotCode } = row;
      const slotCodeName = this.dicMap.sbr_slot[slotCode];
      const str = [hlcCode, siteName, slotCodeName].filter(val => val).join('/');
      const tips = this.$t('dms_routeManage.xglxmco', [str]);
      this.editRouteNameModel = {
        title: tips,
        data: row
      };

      this.editRouteNameVisible = true;
    },

    // -todo
    exportTable() {

    },

    getReqData() {
      const ret = {
        ...this.formSearch
      };
      return ret;
    },
    getReqUrl() {
      return apis.hlcSlotRealTimePage;
    },
    onPageChange({ page, size }) {
      this.formSearch.pageNum = page;
      this.formSearch.pageSize = size || this.formSearch.pageSize;
      this.getTableList();
    },
    // 清除
    clearFilter: function () {
      this.$refs.table.clearFilter();
      this.formSearch = JSON.parse(this.resetFormSearch);
      this.onPageChange({ page: 1 });
    },
    getTableList() {
      const url = this.getReqUrl();
      const reqData = this.getReqData();
      this.$getJSON(url, reqData).then((res) => {
        const list = res.data.records;
        list.forEach((item) => {
          const bizType = 'i';
          const bizId = item.mapId;
          this.$getFileList({
            bizId,
            bizType
          }).then((fileList) => {
            const urlList = fileList.map(i => i.url);
            if (urlList.length) {
              this.$set(item, 'thumb', urlList[0]);
            }
          });
        });
        this.tableList = list;
        this.totalRows = res.data.total;
      });
    },
    async onDel(row) {
      const { hlcCode, siteName, slotCode } = row;
      const slotCodeName = this.dicMap.sbr_slot[slotCode];
      const subStr = [hlcCode, siteName, slotCodeName].filter(val => val).join('/');
      const tips = this.$t('dms_routeManage.nqdysclxom', [subStr]);
      await this.$showConfirm(tips);
      const reqUrl = `${apis.hlcSlotDelete}/${row.hlcSlotId}`;
      await this.$postJSON(reqUrl);
      this.$message({
        message: this.$t('Common.com_delete_success'),
        type: 'success'
      });
      this.getTableList();
    },
    async onRecover(row) {
      const { hlcCode, siteName, slotCode, mapName } = row;
      const slotCodeName = this.dicMap.sbr_slot[slotCode];
      const subStr = [hlcCode, siteName, slotCodeName].filter(val => val).join('/');
      const tips = this.$t('dms_routeManage.nqdyhflxoom', [subStr,mapName]);
      await this.$showConfirm(tips);
      const reqUrl = `${apis.hlcSlotRecover}/${row.hlcSlotHistId}`;
      await this.$postJSON(reqUrl);
      this.$message({
        message: this.$t('Common.com_handle_success'),
        type: 'success'
      });
      this.getTableList();
    },
  },
  created() {
  },
  mounted() {
    this.getTableColumn();

    this.resetFormSearch = JSON.stringify(this.formSearch);
    this.getFuncView(null, () => {
      setTimeout(() => {
        this.link = this.$refs.container;
      }, 500);
    });
    this.getDicMap('sbr_slot,hlc_slot_state');
    this.getTableList();
  },
};
</script>

<style lang="scss">
.route-item-bd {
  .tab {
    margin-left: -16px;
    margin-right: -16px;
  }
  .thumb-content {
    width: 80px;
    height: 80px;
  }
}
</style>
